export const needProductIdForDefaultFilters: Array<string> = [
  'advertisement-integrations',
  'hypotheses-product-card'
]

export const needArticleIdForDefaultFilters: Array<string> = [
  'notes-product-card',
  'price-levels-product-card'
]
